// ----------------------------------------------------------------------

import { HelmetProvider } from "@vuer-ai/react-helmet-async";
import MainLayout from "./layouts/MainLayout";
import Router from "./routes";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function App() {
  return (
    <HelmetProvider>
      <MainLayout>
        <Router />
      </MainLayout>
    </HelmetProvider>
  );
}
